import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/vgt";
import { Reveal, SectionHeader } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-20 sm:py-28 px-4 sm:px-8">
    <div className="max-w-3xl mx-auto">
      <SectionHeader
        align="center"
        eyebrow="07 · FAQ"
        title="Questions Buyers Ask Us"
      />
      <Reveal>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#E6DEC3]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif font-semibold text-base sm:text-lg text-[#2C1A0C] hover:text-[#2E4F3E] py-5 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-sm sm:text-base text-[#6E5B4F] leading-relaxed pb-5"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
